
















































import Vue from 'vue'
import {mapActions, mapState, mapMutations} from 'vuex'

export default Vue.extend({
    data: () => ({
        ubicazione: '',
        tipo_segnalazione: 1,
        descrizione: ''
    }),
    computed: {
        ...mapState('reportMappa', ['centroMappa']),
        ...mapState('user', ['userInfo']),
        ...mapState('upload', ['stagedFiles']),
        nuoviDati() {
            return {
                descrizione: this.descrizione,
                latitudine: this.centroMappa[1],
                longitudine: this.centroMappa[0],
                tipo_segnalazione_id: this.tipo_segnalazione,
                ubicazione: this.ubicazione,
                url_foto: this.stagedFiles.length > 0 ? this.stagedFiles[0].url : undefined
            }
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('reportAdmin', ['salvaSegnalazione']),
        ...mapMutations('upload', ['RESET_STAGED_FILES']),
        // metodo ricavare l indirizzo a partire dalle coordinate
        async getIndirizzoDaCoordinate() {
            try {
                const response = await Vue.axios.get('https://home.tecnograph-group.com/geocodermassivo/reversegeocode', {
                    params: {
                        longitudine: this.centroMappa[0],
                        latitudine: this.centroMappa[1]
                    }
                })
                if (!response.data.errore) this.ubicazione = response.data.indirizzoCompleto
            } catch (err) {
                console.error(err)
            }
        },
        clientUpload(file) {
            this.$store.dispatch('upload/clientUpload', file)
        }

    },
    mounted() {
        this.RESET_STAGED_FILES()
        this.getIndirizzoDaCoordinate()
    }
})
